/**
 * Build FAQPage JSON-LD from { question, answer } pairs.
 * Pass the result to Seo's jsonLd prop, or include it in a jsonLd array.
 */
export function faqPageSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: {
        "@type": "Answer",
        text: answer,
      },
    })),
  };
}
